import { SliderThumbnails } from "../../blocks/slider/views/SliderThumbnails-front.js";
import { createSvgicon, createSvgiconString } from "../../blocks/svgicons/front.js";
import { breakpointBiggerThan, getBreakpoint } from "../../js/breakpoints.js";



const dom = {
    getMedias: $element => [...$element.querySelectorAll("img,video")]
};

/**
 * 
 * Pour créer une lightbox, il suffit d'ajouter la classe has-lightbox
 * 
 */
export class LightBox{

    //----------------------------------------------- STATIC --------------------------------------------------------

    // class à mettre sur un conteneur d'images demandant une lightbox
    static triggerClass = "has-lightbox";

    static instances = [];

    /**
     * Ajoute toutes les lightboxes aux éléments contenant des images et portant déjà la class LightBox.triggerClass
     * Elles devront toutes partager le même breakpoint
     * @param {string} breakpoint le breakpoint à partir duquel déclencher la lightbox
     */
    static addAll(breakpoint="base"){
        const allLightboxes = [...document.querySelectorAll("."+LightBox.triggerClass)];
        LightBox.instances  = allLightboxes.map($element => new LightBox($element));
    }

    /**
     * Ajoute une lightbox à un element content des images (et lui ajoute la class LightBox.triggerClass)
     * @param {Element} $imgContainer Element dans lequel se trouve les images (ou leur conteneur)
     * @param {string} breakpoint le breakpoint à partir duquel déclencher la lightbox
     */
    static add($imgContainer, breakpoint="base"){
        if($imgContainer instanceof Element){
            $imgContainer.classList.add(LightBox.triggerClass);
            LightBox.instances.push(new LightBox($imgContainer, breakpoint));
        }
    }

    //----------------------------------------------- INSTANCE --------------------------------------------------------

    element    = null;
    slider     = null;
    opened     = false;
    breakpoint = "base";

    /**
     * 
     * @param {Element} $element 
     * @param {string} breakpoint Taille d'écran à partir de laquelle lightbox est activée
     */
    constructor($element, breakpoint="base"){
        this.element    = $element;
        this.breakpoint = breakpoint;
        $element.addEventListener('click', this.onClickImgs);
        window.addEventListener("resize", this.update);
        this.update();
    }

    update = () =>{
        const $children = [...this.element.children];
        if(breakpointBiggerThan(this.breakpoint)){     
            $children.forEach($child => $child.classList.add("open-lightbox"));
        } else {
            $children.forEach($child => $child.classList.remove("open-lightbox"));
        }
    }

    onClickImgs = (e) =>{
        if(breakpointBiggerThan(this.breakpoint) && (e.target.tagName === "IMG" || e.target.tagName === "VIDEO")){
            this.open(e.target);
        }
    }

    /**
     * Ouvre lightbox
     * @param {Element} $mediaClicked 
     */
    open($mediaClicked){
        this.opened = true;
        let index = 0; 
        const $medias = dom.getMedias(this.element).map(($media, i) => {
            // on en profite pour capter l'index du media qui vient d'être cliqué
            if($mediaClicked.isEqualNode($media)) 
                index = i;
            // création des SLIDES
            const src = $media.dataset.fullSrc 
                ? $media.dataset.fullSrc 
                : $media.src;
            return `<div class="slide container-slide ofh"><img src="${src}" class="bk contain" /></div>`;
        });
        
        let $slider = SliderThumbnails.createElement("lightbox-slider", $medias.join(""));

        document.body.insertAdjacentHTML("beforeend", `
            <div class="lightbox" id="lightbox-main">
                <div class="lightbox-content">
                    ${$slider.outerHTML}
                </div>     
                <button class="lightbox-close" id="lightbox-close">
                    ${createSvgiconString("close")}
                </button>
            </div>
        `);

        const $btn = document.getElementById("lightbox-close");
        $btn.addEventListener("click", this.close, {once: true});
        $slider = document.getElementById("lightbox-slider");
        this.slider = new SliderThumbnails($slider);
        const [prev, next, es] = this.slider.getDom("btns");
        if(prev instanceof Element && next instanceof Element){
            prev.style.left  = "-9%";
            next.style.right = "-9%";
        }
        this.slider.position(index);
    }

    /**
     * Ferme lightbox
     */
    close = () =>{
        if(this.opened === true){
            this.opened = false;
            this.slider.destroy();//console.log({slider:this.slider});
            this.slider = null;
            document.getElementById("lightbox-main").remove();
        }      
    }
}